const actionTypes = {
    SET_BOOK_ACCESS_CREDENTIALS: 'BOOK_ACCESS/SET_CREDENTIALS',
    UPDATE_BOOK_ACCESS_CREDENTIALS: 'BOOK_ACCESS/UPDATE_CREDENTIALS',

    GET_BOOK_ACCESS_REQUEST: 'BOOK_ACCESS/GET_REQUEST',
    UPDATE_BOOK_ACCESS_REQUEST: 'BOOK_ACCESS/UPDATE_REQUEST',
};

export default actionTypes;
